import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
    const { user } = useSelector((state) => state.auth);

    if (user) {
        if (user.mustChangePassword) {
            return <Navigate to="/force-change-password" replace />;
        }
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PublicRoute;
